import { useCallback, type KeyboardEvent } from 'react';
import type { NoteItem } from '../../doc/schema';
import { useBoard, usePane, usePaneStore } from '../context';
import { textStyleCss, textStyleOf } from '../text/textStyle';

export function NoteBody({ item }: { item: NoteItem }) {
  const editing = usePane((s) => s.editingId === item.id);
  const pane = usePaneStore();
  const board = useBoard();

  const commit = useCallback(
    (text: string) => {
      if (text !== item.props.text) board.updateItem(item.id, { props: { text } });
      pane.getState().setEditing(null);
    },
    [board, item.id, item.props.text, pane],
  );

  const onKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    e.stopPropagation();
    if (e.key === 'Escape') e.currentTarget.blur();
  };

  // Sticky notes are light paper: default ink is dark regardless of theme.
  const style = textStyleCss(textStyleOf(item), '#111111');

  if (editing) {
    return (
      <textarea
        className="note-editor"
        style={style}
        defaultValue={item.props.text}
        autoFocus
        spellCheck={false}
        onPointerDown={(e) => e.stopPropagation()}
        onKeyDown={onKeyDown}
        onBlur={(e) => commit(e.currentTarget.value)}
        onFocus={(e) => e.currentTarget.select()}
      />
    );
  }

  return (
    <div className="note-text" style={style}>
      {item.props.text || <span className="placeholder">Double-click to write</span>}
    </div>
  );
}
